// frontend/smartdocs-admin/src/components/settings/IntegrationsSettings.tsx
import React from 'react';
import { useSettings } from '@/context/SettingsContext';
import ToggleSwitch from '@shared/ToggleSwitch';
import SettingsPage from "@/pages/SettingsPage";
import Card from "@shared/Card";
import Input from "@shared/Input";

const IntegrationsSettings: React.FC = () => {
  const { settings, updateSetting, loading } = useSettings();

  const integrationsSettings = settings.Integrations || {};

  const handleUpdate = (key: string, value: any) => {
    updateSetting('Integrations', key, value);
  };

  return (
    <SettingsPage>
      <Card>
        <div className="space-y-6">
      {/*<h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">Integrations Settings</h2>*/}

      {/* Enable Slack Integration */}
      <div className="flex items-center justify-between">
        <div>
          <label htmlFor="enableSlackIntegration" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Enable Slack Integration</label>
          <p className="text-sm text-gray-500 dark:text-gray-400">Connect SmartDocs AI with your Slack workspace for notifications and commands.</p>
        </div>
        <ToggleSwitch
          id="enableSlackIntegration"
          label=""
          checked={integrationsSettings.enableSlackIntegration || false}
          onChange={(e) => handleUpdate('enableSlackIntegration', e.target.checked)}
          disabled={loading}
        />
      </div>

      {/* Slack Webhook URL */}
      <div>
        <label htmlFor="slackWebhookUrl" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Slack Webhook URL</label>
        <p className="text-sm text-gray-500 dark:text-gray-400 mb-2">Enter the webhook URL for sending notifications to Slack.</p>

        <Input
          type="url"
          id="slackWebhookUrl"
          className="p-2 mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
          value={integrationsSettings.slackWebhookUrl || ''}
          onChange={(e) => handleUpdate('slackWebhookUrl', e.target.value)}
          disabled={loading}
        />
      </div>

      {/* Enable Jira Integration */}
      <div className="flex items-center justify-between">
        <div>
          <label htmlFor="enableJiraIntegration" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Enable Jira Integration</label>
          <p className="text-sm text-gray-500 dark:text-gray-400">Integrate with Jira for issue tracking and project management.</p>
        </div>
        <ToggleSwitch
          id="enableJiraIntegration"
          label=""
          checked={integrationsSettings.enableJiraIntegration || false}
          onChange={(e) => handleUpdate('enableJiraIntegration', e.target.checked)}
          disabled={loading}
        />
      </div>

      {/* Jira API Key */}
      <div>
        <label htmlFor="jiraApiKey" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Jira API Key</label>
        <p className="text-sm text-gray-500 dark:text-gray-400 mb-2">API key for authenticating with your Jira instance.</p>
        <Input
          type="password"
          id="jiraApiKey"
          className="p-2 mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
          value={integrationsSettings.jiraApiKey || ''}
          onChange={(e) => handleUpdate('jiraApiKey', e.target.value)}
          disabled={loading}
        />
      </div>
    </div>
      </Card>
    </SettingsPage>
  );
};

export default IntegrationsSettings;
